"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USAEmailHelpers = exports.StaticUsaEmailHelpers = void 0;
const DefaultEmailHelpers_1 = require("../DefaultEmailHelpers");
class StaticUsaEmailHelpers extends DefaultEmailHelpers_1.StaticEmailHelpers {
}
exports.StaticUsaEmailHelpers = StaticUsaEmailHelpers;
StaticUsaEmailHelpers.emailRegex = /^([a-zA-Z0-9_\-|~^{}%+/=?.]{1,64})@([a-zA-Z0-9_\-.])+\.([a-zA-Z]{1,6})$/;
class USAEmailHelpers extends StaticUsaEmailHelpers {
    constructor() {
        super(...arguments);
        this.emailRegex = USAEmailHelpers.emailRegex;
    }
    validateEmail(email) {
        return USAEmailHelpers.validateEmail(email, { emailRegex: this.emailRegex });
    }
    obfuscateEmail(email) {
        return USAEmailHelpers.obfuscateEmail(email);
    }
}
exports.USAEmailHelpers = USAEmailHelpers;
//# sourceMappingURL=USAEmailHelpers.js.map